import { Expression } from 'mapbox-gl';

export function createMaxExpression(parameterName: string): Expression {
  if (parameterName === 'gmaAlarm') {
    ['+'];
    return ['max', ['get', parameterName]];
  } else {
    return ['max', ['get', parameterName]];
  }
}

export const WW_ICONS = {
  '0': { day: '9999999', night: '9999999', position: 4 },
  '1': { day: '1999999', night: '2999999', position: 5 },
  '2': { day: '1999999', night: '2999999', position: 6 },
  '3': { day: '1999999', night: '2999999', position: 7 },
  '4': { day: '1999999', night: '2999999', position: 8 },
  '5': { day: '1999999', night: '2999999', position: 9 },
  '6': { day: '1999999', night: '2999999', position: 10 },
  '7': { day: '1999999', night: '2999999', position: 11 },
  '8': { day: '1999999', night: '2999999', position: 12 },
  '9': { day: '1999999', night: '2999999', position: 13 },
  '10': { day: '1999949', night: '2999949', position: 59 },
  '11': { day: '1999949', night: '2999949', position: 60 },
  '12': { day: '1999949', night: '2999949', position: 61 },
  '13': { day: '1199919', night: '2199919', position: 62 },
  '14': { day: '1119999', night: '2119999', position: 63 },
  '15': { day: '1119999', night: '2119999', position: 64 },
  '16': { day: '1119999', night: '2119999', position: 65 },
  '17': { day: '1199919', night: '2199919', position: 66 },
  '18': { day: '1199999', night: '2199999', position: 67 },
  '19': { day: '1199999', night: '2199999', position: 68 },
  '20': { day: '1111999', night: '2111999', position: 69 },
  '21': { day: '1111999', night: '2111999', position: 70 },
  '22': { day: '1111999', night: '2111999', position: 71 },
  '23': { day: '1111999', night: '2111999', position: 72 },
  '24': { day: '1111999', night: '2111999', position: 73 },
  '25': { day: '1111999', night: '2111999', position: 74 },
  '26': { day: '1111999', night: '2111999', position: 75 },
  '27': { day: '1111999', night: '2111999', position: 76 },
  '28': { day: '1299959', night: '2299959', position: 77 },
  '29': { day: '1129919', night: '2129919', position: 78 },
  '30': { day: '1111999', night: '2111999', position: 79 },
  '31': { day: '1111999', night: '2111999', position: 80 },
  '32': { day: '1111999', night: '2111999', position: 81 },
  '33': { day: '1111999', night: '2111999', position: 82 },
  '34': { day: '1111999', night: '2111999', position: 83 },
  '35': { day: '1111999', night: '2111999', position: 84 },
  '36': { day: '1291999', night: '2291999', position: 85 },
  '37': { day: '1291999', night: '2291999', position: 86 },
  '38': { day: '1291999', night: '2291999', position: 87 },
  '39': { day: '1291999', night: '2291999', position: 88 },
  '40': { day: '1299959', night: '2299959', position: 98 },
  '41': { day: '1299959', night: '2299959', position: 99 },
  '42': { day: '1299959', night: '2299959', position: 100 },
  '43': { day: '1299959', night: '2299959', position: 101 },
  '44': { day: '1299959', night: '2299959', position: 102 },
  '45': { day: '1299959', night: '2299959', position: 103 },
  '46': { day: '1299959', night: '2299959', position: 104 },
  '47': { day: '1299959', night: '2299959', position: 105 },
  '48': { day: '1299959', night: '2299959', position: 106 },
  '49': { day: '1299959', night: '2299959', position: 107 },
  '50': { day: '1249999', night: '2249999', position: 161 },
  '51': { day: '1249999', night: '2249999', position: 162 },
  '52': { day: '1249999', night: '2249999', position: 163 },
  '53': { day: '1249999', night: '2249999', position: 164 },
  '54': { day: '1249999', night: '2249999', position: 165 },
  '55': { day: '1249999', night: '2249999', position: 166 },
  '56': { day: '1249999', night: '2249999', position: 167 },
  '57': { day: '1249999', night: '2249999', position: 168 },
  '58': { day: '1249999', night: '2249999', position: 169 },
  '59': { day: '1249999', night: '2249999', position: 170 },
  '60': { day: '1229999', night: '2229999', position: 180 },
  '61': { day: '1229999', night: '2229999', position: 181 },
  '62': { day: '1229999', night: '2229999', position: 182 },
  '63': { day: '1229999', night: '2229999', position: 183 },
  '64': { day: '1229999', night: '2229999', position: 184 },
  '65': { day: '1229999', night: '2229999', position: 185 },
  '66': { day: '1229999', night: '2229999', position: 186 },
  '67': { day: '1229999', night: '2229999', position: 187 },
  '68': { day: '1229999', night: '2229999', position: 188 },
  '69': { day: '1229999', night: '2229999', position: 189 },
  '70': { day: '1292999', night: '2292999', position: 199 },
  '71': { day: '1292999', night: '2292999', position: 200 },
  '72': { day: '1292999', night: '2292999', position: 201 },
  '73': { day: '1292999', night: '2292999', position: 202 },
  '74': { day: '1292999', night: '2292999', position: 203 },
  '75': { day: '1292999', night: '2292999', position: 204 },
  '76': { day: '1292999', night: '2292999', position: 205 },
  '77': { day: '1292999', night: '2292999', position: 206 },
  '78': { day: '1292999', night: '2292999', position: 207 },
  '79': { day: '1292999', night: '2292999', position: 208 },
  '80': { day: '1239999', night: '2239999', position: 218 },
  '81': { day: '1239999', night: '2239999', position: 219 },
  '82': { day: '1239999', night: '2239999', position: 220 },
  '83': { day: '1222999', night: '2222999', position: 221 },
  '84': { day: '1222999', night: '2222999', position: 222 },
  '85': { day: '1292999', night: '2292999', position: 223 },
  '86': { day: '1292999', night: '2292999', position: 224 },
  '87': { day: '1299299', night: '2299299', position: 225 },
  '88': { day: '1299299', night: '2299299', position: 226 },
  '89': { day: '1299299', night: '2299299', position: 227 },
  '90': { day: '1299299', night: '2299299', position: 237 },
  '91': { day: '1119919', night: '2119919', position: 238 },
  '92': { day: '1129919', night: '1129919', position: 239 },
  '93': { day: '1119919', night: '2119919', position: 240 },
  '94': { day: '1129919', night: '1129919', position: 241 },
  '95': { day: '1119919', night: '2119919', position: 242 },
  '96': { day: '1129919', night: '1129919', position: 243 },
  '97': { day: '1219919', night: '2219919', position: 244 },
  '98': { day: '1219919', night: '2219919', position: 245 },
  '99': { day: '1229919', night: '2229919', position: 246 },
  '100': { day: '1199999', night: '2199999', position: 14 },
  '101': { day: '1199999', night: '2199999', position: 15 },
  '102': { day: '1199999', night: '2199999', position: 16 },
  '103': { day: '1199999', night: '2199999', position: 17 },
  '104': { day: '1199999', night: '2199999', position: 18 },
  '105': { day: '1199999', night: '2199999', position: 19 },
  '110': { day: '1999949', night: '2999949', position: 20 },
  '111': { day: '1199199', night: '2199199', position: 21 },
  '112': { day: '1199919', night: '2199919', position: 22 },
  '118': { day: '1199999', night: '2199999', position: 23 },
  '120': { day: '1999949', night: '2999949', position: 24 },
  '121': { day: '1111999', night: '2111999', position: 25 },
  '122': { day: '1111999', night: '2111999', position: 26 },
  '123': { day: '1111999', night: '2111999', position: 27 },
  '124': { day: '1111999', night: '2111999', position: 28 },
  '125': { day: '1111999', night: '2111999', position: 29 },
  '126': { day: '1111999', night: '2111999', position: 30 },
  '127': { day: '1111999', night: '2111999', position: 31 },
  '128': { day: '1111999', night: '2111999', position: 32 },
  '129': { day: '1111999', night: '2111999', position: 33 },
  '130': { day: '1199959', night: '2199959', position: 34 },
  '131': { day: '1199959', night: '2199959', position: 35 },
  '132': { day: '1199959', night: '2199959', position: 36 },
  '133': { day: '1199959', night: '2199959', position: 37 },
  '134': { day: '1199959', night: '2199959', position: 38 },
  '135': { day: '1199959', night: '2199959', position: 39 },
  '140': { day: '1129999', night: '2129999', position: 89 },
  '141': { day: '1129999', night: '2129999', position: 90 },
  '142': { day: '1129999', night: '2129999', position: 91 },
  '143': { day: '1129999', night: '2129999', position: 92 },
  '144': { day: '1129999', night: '2129999', position: 93 },
  '145': { day: '1192999', night: '2192999', position: 94 },
  '146': { day: '1192999', night: '2192999', position: 95 },
  '147': { day: '1192999', night: '2192999', position: 96 },
  '148': { day: '1192999', night: '2192999', position: 97 },
  '150': { day: '1249999', night: '2249999', position: 152 },
  '151': { day: '1249999', night: '2249999', position: 153 },
  '152': { day: '1249999', night: '2249999', position: 154 },
  '153': { day: '1249999', night: '2249999', position: 155 },
  '154': { day: '1249999', night: '2249999', position: 156 },
  '155': { day: '1249999', night: '2249999', position: 157 },
  '156': { day: '1249999', night: '2249999', position: 158 },
  '157': { day: '1249999', night: '2249999', position: 159 },
  '158': { day: '1249999', night: '2249999', position: 160 },
  '160': { day: '1229999', night: '2229999', position: 171 },
  '161': { day: '1229999', night: '2229999', position: 172 },
  '162': { day: '1229999', night: '2229999', position: 173 },
  '163': { day: '1229999', night: '2229999', position: 174 },
  '164': { day: '1229999', night: '2229999', position: 175 },
  '165': { day: '1229999', night: '2229999', position: 176 },
  '166': { day: '1229999', night: '2229999', position: 177 },
  '167': { day: '1229999', night: '2229999', position: 178 },
  '168': { day: '1229999', night: '2229999', position: 179 },
  '170': { day: '1292999', night: '2292999', position: 190 },
  '171': { day: '1292999', night: '2292999', position: 191 },
  '172': { day: '1292999', night: '2292999', position: 192 },
  '173': { day: '1292999', night: '2292999', position: 193 },
  '174': { day: '1292999', night: '2292999', position: 194 },
  '175': { day: '1292999', night: '2292999', position: 195 },
  '176': { day: '1292999', night: '2292999', position: 196 },
  '177': { day: '1292999', night: '2292999', position: 197 },
  '178': { day: '1292999', night: '2292999', position: 198 },
  '180': { day: '1239999', night: '2239999', position: 209 },
  '181': { day: '1239999', night: '2239999', position: 210 },
  '182': { day: '1239999', night: '2239999', position: 211 },
  '183': { day: '1222999', night: '2222999', position: 212 },
  '184': { day: '1222999', night: '2222999', position: 213 },
  '185': { day: '1292999', night: '2292999', position: 214 },
  '186': { day: '1292999', night: '2292999', position: 215 },
  '187': { day: '1299299', night: '2299299', position: 216 },
  '188': { day: '1299299', night: '2299299', position: 217 },
  '190': { day: '1299299', night: '2299299', position: 228 },
  '191': { day: '1119919', night: '2119919', position: 229 },
  '192': { day: '1129919', night: '1129919', position: 230 },
  '193': { day: '1119919', night: '2119919', position: 231 },
  '194': { day: '1129919', night: '1129919', position: 232 },
  '195': { day: '1119919', night: '2119919', position: 233 },
  '196': { day: '1129919', night: '1129919', position: 234 },
  '197': { day: '1219919', night: '2219919', position: 235 },
  '198': { day: '1219919', night: '2219919', position: 236 },
  '204': { day: '1199999', night: '2199999', position: 40 },
  '206': { day: '1199999', night: '2199999', position: 41 },
  '207': { day: '1199999', night: '2199999', position: 42 },
  '208': { day: '1199999', night: '2199999', position: 43 },
  '209': { day: '1199999', night: '2199999', position: 44 },
  '210': { day: '1199999', night: '2199999', position: 45 },
  '211': { day: '1199999', night: '2199999', position: 46 },
  '213': { day: '1199919', night: '2199919', position: 47 },
  '217': { day: '1199919', night: '2199919', position: 48 },
  '219': { day: '1199919', night: '2199919', position: 49 },
  '241': { day: '1199959', night: '2199959', position: 50 },
  '242': { day: '1199959', night: '2199959', position: 51 },
  '243': { day: '1199959', night: '2199959', position: 52 },
  '244': { day: '1199959', night: '2199959', position: 53 },
  '245': { day: '1199959', night: '2199959', position: 54 },
  '246': { day: '1199959', night: '2199959', position: 55 },
  '247': { day: '1199959', night: '2199959', position: 56 },
  '248': { day: '1199959', night: '2199959', position: 57 },
  '249': { day: '1199959', night: '2199959', position: 58 },
  '250': { day: '1149999', night: '2149999', position: 108 },
  '251': { day: '1149999', night: '2149999', position: 109 },
  '252': { day: '1149999', night: '2149999', position: 110 },
  '253': { day: '1149999', night: '2149999', position: 111 },
  '254': { day: '1149999', night: '2149999', position: 112 },
  '255': { day: '1149999', night: '2149999', position: 113 },
  '256': { day: '1149999', night: '2149999', position: 114 },
  '257': { day: '1149999', night: '2149999', position: 115 },
  '258': { day: '1149999', night: '2149999', position: 116 },
  '259': { day: '1149999', night: '2149999', position: 117 },
  '260': { day: '1129999', night: '2129999', position: 118 },
  '261': { day: '1129999', night: '2129999', position: 119 },
  '262': { day: '1129999', night: '2129999', position: 120 },
  '263': { day: '1129999', night: '2129999', position: 121 },
  '264': { day: '1129999', night: '2129999', position: 122 },
  '265': { day: '1129999', night: '2129999', position: 123 },
  '266': { day: '1129999', night: '2129999', position: 124 },
  '267': { day: '1129999', night: '2129999', position: 125 },
  '268': { day: '1129999', night: '2129999', position: 126 },
  '269': { day: '1129999', night: '2129999', position: 127 },
  '270': { day: '1192999', night: '2192999', position: 128 },
  '271': { day: '1192999', night: '2192999', position: 129 },
  '272': { day: '1192999', night: '2192999', position: 130 },
  '273': { day: '1192999', night: '2192999', position: 131 },
  '274': { day: '1192999', night: '2192999', position: 132 },
  '275': { day: '1192999', night: '2192999', position: 133 },
  '276': { day: '1192999', night: '2192999', position: 134 },
  '277': { day: '1192999', night: '2192999', position: 135 },
  '278': { day: '1192999', night: '2192999', position: 136 },
  '279': { day: '1192999', night: '2192999', position: 137 },
  '280': { day: '1129999', night: '2129999', position: 138 },
  '281': { day: '1129999', night: '2129999', position: 139 },
  '282': { day: '1129999', night: '2129999', position: 140 },
  '283': { day: '1192999', night: '2192999', position: 141 },
  '284': { day: '1192999', night: '2192999', position: 142 },
  '285': { day: '1192999', night: '2192999', position: 143 },
  '286': { day: '1192999', night: '2192999', position: 144 },
  '287': { day: '1192999', night: '2192999', position: 145 },
  '288': { day: '1199299', night: '2199299', position: 146 },
  '289': { day: '1199299', night: '2199299', position: 147 },
  '290': { day: '1199299', night: '2199299', position: 148 },
  '291': { day: '1199299', night: '2199299', position: 149 },
  '292': { day: '1229919', night: '2229919', position: 150 },
  '293': { day: '1229919', night: '2229919', position: 151 },
  '508': { day: '9999999', night: '9999999', position: 1 },
  '509': { day: '9999999', night: '9999999', position: 2 },
  '510': { day: '9999999', night: '9999999', position: 3 },
};

export const N_NLOW_ICONS = {
  '0': 'WeatherSymbol_WMO_TotalCloudCover_N_0',
  '1': 'WeatherSymbol_WMO_TotalCloudCover_N_1',
  '2': 'WeatherSymbol_WMO_TotalCloudCover_N_2',
  '3': 'WeatherSymbol_WMO_TotalCloudCover_N_3',
  '4': 'WeatherSymbol_WMO_TotalCloudCover_N_4',
  '5': 'WeatherSymbol_WMO_TotalCloudCover_N_5',
  '6': 'WeatherSymbol_WMO_TotalCloudCover_N_6',
  '7': 'WeatherSymbol_WMO_TotalCloudCover_N_7',
  '8': 'WeatherSymbol_WMO_TotalCloudCover_N_8',
  '9': 'WeatherSymbol_WMO_TotalCloudCover_N_9',
};
